import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
export const toCustomPageDTO = (page)=>{
    if (page.type !== 'text') return page;
    const _page_text = page.text, { isEmpty: _isEmpty, saveFailed: _saveFailed } = _page_text, text = _object_without_properties(_page_text, [
        "isEmpty",
        "saveFailed"
    ]);
    return _object_spread_props(_object_spread({}, page), {
        text
    });
};
